<template>
  <div>     
    <v-container grid-list-md fluid>
      <v-layout align-center justify-space-around wrap>
        <v-flex md12>
          <v-toolbar color="primary" dark dense>
            <v-toolbar-title>
              Apps
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                text
                small
                @click.prevent="refresh()"
              >
                <v-icon color="primary" small>refresh</v-icon>
                Refresh Namespaces
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
        </v-flex>

        <v-flex md12>
          <v-card>
            <v-card-title>
            <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="Object.values(allApps)"
                :sort-by="'clustername'"
                :footer-props="{
                  'items-per-page-options': [10, 50, 100]
                }"
                :items-per-page=50
                :search="search"
                item-key="clustername+namespace+name"
                class="elevation-1"
                dense
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.clustername+item.namespace+item.name" @click.prevent="showApp(item)" :style="{cursor:'pointer'}">
                      <td>{{ allClusters[item.clustername].prettyname }}</td>
                      <td>{{ item.namespace }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.kind }}</td>
                      <td>
                        <v-icon v-if="item.status.readyreplicas == 0 && item.status.replicas > 0" small color="error">warning</v-icon>
                        <v-icon v-else-if="item.status.readyreplicas == 0 && item.status.replicas == 0" small color="warning">stop</v-icon>
                        <v-icon v-else-if="item.status.readyreplicas < item.status.replicas" small color="warning">hourglass_full</v-icon>
                        <v-icon v-else-if="item.status.readyreplicas == item.status.replicas" small color="success">done</v-icon>
                        {{ item.status.readyreplicas }}/{{ item.status.replicas }}
                      </td>
                      <td>{{ smallStr(item.containersList[0].image.split(":")[1], 32) }}</td>
                  </tr>
                </tbody>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

      </v-layout>
    </v-container>

    <v-dialog
      v-model="infodialog"
      hide-overlay
      width="650"
    >
      <v-card v-if="selectedApp">
        <v-card-title>{{ selectedApp.name }}</v-card-title>
        <v-card-text>
          <v-simple-table dense>
            <tbody>
              <tr>
                <td>Name</td>
                <td>{{ selectedApp.name }}</td>
              </tr>
              <tr>
                <td>Kind</td>
                <td>{{ selectedApp.kind }}</td>
              </tr>
              <tr>
                <td>Cluster</td>
                <td>{{ selectedApp.clustername }}</td>
              </tr>
              <tr>
                <td>Namespace</td>
                <td>{{ selectedApp.namespace }}</td>
              </tr>
              <tr>
                <td>Status</td>
                <td>
                  <v-icon v-if="selectedApp.status.readyreplicas == 0 && selectedApp.status.replicas > 0" small color="error">warning</v-icon>
                  <v-icon v-else-if="selectedApp.status.readyreplicas == 0 && selectedApp.status.replicas == 0" small color="warning">stop</v-icon>
                  <v-icon v-else-if="selectedApp.status.readyreplicas < selectedApp.status.replicas" small color="warning">hourglass_full</v-icon>
                  <v-icon v-else-if="selectedApp.status.readyreplicas == selectedApp.status.replicas" small color="success">done</v-icon>
                  {{ selectedApp.status.readyreplicas }}/{{ selectedApp.status.replicas }}
                </td>
              </tr>
              <tr>
                <td>Init Containers</td>
                <td>
                  <v-simple-table dense>
                    <tbody v-for="ctn in selectedApp.initcontainersList" :key="ctn.name">
                      <tr>
                        <td>Name</td>
                        <td>{{ ctn.name }}</td>
                      </tr>
                      <tr>
                        <td>Image</td>
                        <td>{{ ctn.image }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </td>
              </tr>
              <tr>
                <td>Containers</td>
                <td>
                  <v-simple-table dense>
                    <tbody v-for="ctn in selectedApp.containersList" :key="ctn.name">
                      <tr>
                        <td>Name</td>
                        <td>{{ ctn.name }}</td>
                      </tr>
                      <tr>
                        <td>Image</td>
                        <td>{{ ctn.image }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="infodialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      search: '',
      clustername: null,
      headers: [
        { text: 'Cluster', sortable: true, value: 'clustername' },
        { text: 'Namespace', sortable: true, value: 'namespace' },
        { text: 'Name', sortable: true, value: 'name' },
        { text: 'Kind', sortable: true, value: 'kind' },
        { text: 'Status', sortable: true, value: 'status.readyreplicas' },
        { text: 'Version', sortable: false, value: 'containersList' }
      ],
      selectedApp: null,
      infodialog: false,
    }
  },
  computed: {
    ...mapGetters(['allClusters', 'allNamespaces', 'allApps'])
  },
  components: {
  },
  created() {
    this.cancelStreams();
    this.refresh();
  },
  beforeDestroy() {
    this.cancelStreams();
  },
  methods: {
    refresh() {
      this.resetApps();
      this.listClusters().then(() => {
        Object.values(this.allClusters).forEach((cl) => {
          this.listNamespaces({ clustername: cl.name }).then((nss) => {
            Object.values(nss).filter((ns) =>  ns.name != 'cron' && !ns.name.startsWith('kube')).forEach((ns) => {
              this.watchApps({"namespace": ns.name, "clustername": cl.name});
            });
          });
        });
      });
    },
    showApp(app) {
      var a = this.allApps[app.clustername+app.namespace+app.name];
      if (a) {
        this.selectedApp = a;
        this.infodialog = true;
      }
    },
    smallStr(v, n) {
      if (v && n && v.length > n && n > 3) {
        return v.slice(0, n-3) + "...";
      }
      return v
    },
    ...mapActions(['listClusters', 'listNamespaces', 'watchApps', 'resetApps', 'cancelStreams'])
  }
}
</script>
